import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]基金页面类型
 */
export function queryFundPageTypeUsingPOST(
  req: InfoCodeDto | void,
  config?: RequestConfig
): Promise<ApiResultFundPageTypeDto> {
  return resource.postNoAuth('/common/queryFundPageType', req, config);
}

/**
 * 查询特殊人群风险揭示书所需信息
 */
export function specialUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultSpecialDto> {
  return resource.post('/common/risk/special', req, config);
}

/**
 * 特殊人群风险揭示书留痕
 */
export function saveUsingPOST_1(req: SepcialDto | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/common/risk/special/save', req, config);
}

/**
 * 查询是否需要签署风险揭示书
 */
export function searchUsingPOST_2(req: SepcialDto | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/common/risk/special/search', req, config);
}
